module.exports = __webpack_public_path__ + "img/carbon_primary_positive_RGB.8ad3546d.png";